import React, { type JSX } from 'react';

interface IButtonIcon {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'submit' | 'reset' | 'button';
  ariaLabel?: string;
  children: React.ReactNode;
  hasShadow?: boolean;
  width?: string;
  height?: string;
  disabled?: boolean;
}

/**
 * @deprecated Use css utils .tw-lf-button-icon instead
 */
const ButtonIcon = ({
  children,
  onClick,
  type = 'button',
  ariaLabel,
  hasShadow = true,
  width = '44px',
  height = '44px',
  disabled = false,
}: IButtonIcon): JSX.Element => {
  return (
    <>
      <button
        onClick={onClick}
        type={type}
        aria-label={ariaLabel}
        disabled={disabled}
      >
        {children}
      </button>
      <style jsx>{`
        button {
          cursor: pointer;
          width: ${width};
          height: ${height};
          border-radius: 50%;
          background: #fff;
          border: none;
          box-shadow: ${hasShadow ? '0 0 4px 0 rgba(0, 0, 0, 0.2)' : 'none'};
        }

        button:active {
          opacity: 0.6;
        }
      `}</style>
    </>
  );
};

export default ButtonIcon;
